<template>
  <div
    :class="[
      'randomizer-popup',
      `randomizer-popup__valign-${popUpValign}`,
      {'randomizer-popup__top': top0}
    ]"
  >
    <VueCustomScrollbar class="scroll-area">
      <div v-bind:is="popUpComponent" class="randomizer-popup_content" />
    </VueCustomScrollbar>
    <button
      v-if="popUpCanClose"
      class="dialog_close"
      @click="$root.$emit('closeRandomRewardsPopUp')"
    />
  </div>
</template>

<script>
import VueCustomScrollbar from 'vue-custom-scrollbar'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Mutation } from 'vuex-class'

@Component({
  components: {
    VueCustomScrollbar
  }
})
class PopUp extends Vue {
  @Mutation('ui/SET_SCROLL_LOCK') setScrollLock

  @Prop({
    type: Function,
    required: true
  }) popUpComponent

  @Prop({
    type: String,
    default: 'center'
  }) popUpValign

  @Prop({
    type: Boolean,
    default: true
  }) popUpCanClose

  top0 = Boolean(window.pageYOffset || document.documentElement.scrollTop)

  mounted () {
    this.setScrollLock(true)
  }
  destroyed () {
    this.setScrollLock(false)
  }
}

export default PopUp
</script>

<style lang="scss">
  .scroll-area {
    position: relative;
    margin: auto;
    width: 100%;
    height: 100%;
  }
  .randomizer-popup {
    position: fixed;
    left: 0;
    top: 55px;
    width: 100vw;
    height: calc(100% - 55px);
    background: rgba(#181818, .992);
    z-index: 10;
    display: flex;
    justify-content: center;
    @include media_desktop {
      top: calc(55px + 72px);
      height: calc(100% - (55px + 72px));
    }
    &__valign-center {
      align-items: center;
      .ps-container {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
      }
    }
    &__valign-top {
      align-items: flex-start;
    }
    &__top {
      top: 0;
      height: 100%;
    }
    &_content {
      width: 100%;
      padding-top: 30px;
      @include media_desktop {
        padding-top: 0;
      }
    }
  }
</style>
